import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import { Button } from "../../../Button/index.js";
import i18n from "../../i18n/index.js";
const FilterFooter = ()=>{
    const { languageCode } = useTranslation();
    const t = i18n[languageCode];
    return /*#__PURE__*/ jsx("div", {
        className: "tw-sticky tw-bg-neutral-light-200 tw-b-0 tw-w-full tw-px-2.4 tw-py-1.6 tw-flex tw-w-full tw-justify-end tw-items-center dark:tw-bg-elevation-dark-02",
        children: /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("button", {
                    type: "button",
                    onClick: ()=>{},
                    className: "tw-text-link-s hover:tw-text-neutral-light-700 tw-cursor-pointer tw-text-neutral-light-700 tw-mr-2.4",
                    children: t.SAVE_FILTERS_BUTTON_CANCEL
                }),
                /*#__PURE__*/ jsx(Button, {
                    type: "button",
                    variant: "primary",
                    size: "xs",
                    onClick: ()=>{},
                    children: t.SAVE_FILTERS_BUTTON_SAVE
                })
            ]
        })
    });
};
export { FilterFooter };
